export default class Store {
  static getVuexStoreModule() {
    const store = import("@/store/account-store");
    return store.then(module => {
      return module.accountStore;
    });
  }
  static getAccountStoreModule() {
    const store = import("@/store/account-store");
    return store.then(module => {
      return module.accountStore;
    });
  }
}
